import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-creation-massive-error-modal-modal',
  templateUrl: './creation-massive-error-modal.component.html',
  styleUrls: ['./creation-massive-error-modal.component.scss'],
})
export class CreationMassiveErrorModalComponent implements OnInit {
  submit: Subject<any>;
  public invoiceMatrix!: any;
  constructor(private modalRef: BsModalRef) {
    this.submit = new Subject();
  }

  ngOnInit(): void {}

  close() {
    this.submit.next('closed');
    this.modalRef.hide();
  }
}
